import { useCallback, useMemo, useState } from 'react';

/**
 * Thin layer over `useOpenGraph`'s output that lets the user dismiss
 * individual link previews (by URL) without re-fetching. Dismissed URLs
 * are tracked in a `Set`; the filtered array is re-derived only when
 * either the incoming data or the dismissal set changes.
 */
const useOpenGraphFilter = (openGraphData) => {
  const [removedUrls, setRemovedUrls] = useState(() => new Set());

  const handleRemoveOpenGraphCard = useCallback((url) => {
    setRemovedUrls((prev) => new Set([...prev, url]));
  }, []);

  const filteredOpenGraphData = useMemo(
    () => (openGraphData || []).filter((data) => !removedUrls.has(data.url)),
    [openGraphData, removedUrls]
  );

  return { filteredOpenGraphData, handleRemoveOpenGraphCard };
};

export default useOpenGraphFilter;
